import React, { useState } from 'react';
import { X, Tag } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <div className="bg-[#fef3e2] border-b border-[#b87333]/20 relative z-50" data-id="element-150" data-mp="i1cw06i58iik">
      <div className="max-w-7xl mx-auto px-4 py-2.5 sm:py-3 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm sm:text-base" data-id="element-151" data-mp="i3fw5jd0fs10">
        <div className="flex items-center gap-2 text-[#b87333] font-semibold text-center" data-id="element-152" data-mp="ryhk4bvjuo20">
          <Tag className="w-4 h-4 sm:w-5 sm:h-5 animate-pulse" data-id="element-153" data-mp="w0cl1f9kizf9" />
          <span data-id="element-154" data-mp="vyrsfv6tdqk1">🎉 LIMITED TIME: Get $50 OFF Your First Service!</span>
        </div>
        <a href="#coupon" onClick={e => {
        const el = document.getElementById('coupon');
        if (el) {
          e.preventDefault();
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }} className="bg-[#b87333] hover:bg-[#a0632a] text-white px-4 py-1.5 rounded-full text-xs sm:text-sm font-bold transition-colors shadow-sm whitespace-nowrap" data-id="element-155" data-mp="10txjt9izjxfi">
          Claim Discount
        </a>
        <button onClick={() => setIsVisible(false)} className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-[#b87333]/60 hover:text-[#b87333] transition-colors" aria-label="Dismiss promo" data-id="element-156" data-mp="1xe82qbg6v0bb">
          <X className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-157" data-mp="2l29512mrxkia" />
        </button>
      </div>
    </div>;
}